import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const StaffMaster = () => {
  const tableHeaders = ["#", "Image", "Staff", "Contact", "Role",  "Action"];
  const [staffData, setStaffData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  // file uploads for three images
  const [profileFile, setProfileFile] = useState(null);
  const [aadharFile, setAadharFile] = useState(null);
  const [licenseFile, setLicenseFile] = useState(null);
const [viewModal, setViewModal] = useState(false);
const [viewData, setViewData] = useState(null);


  const initialForm = {
    id: null,
    name: '',
    contact_no1: '',
    emergency_contact_no: '',
    emergency_contact_relation: '',
    whatsapp_number: '',
    dob: '',
    blood_grp: '',
    marital_status: '',
    aniversary: '',
    profile_image: '',
    current_full_address: '',
    language_known: '',
    spouse_name: '',
    father_name: '',
    mother_name: '',
    bank_acno: '',
    bank_ifsc: '',
    bank_name: '',
    bank_branch: '',
    aadhar_proof: '',
    gender: '',
    relegion: '',
    native_full_address: '',
    driving_skill: '',
    driving_license: '',
    any_medical_issue: '',
    role: '',
    current_salary: '',
    fingerprint_id: '',
    // is_active: 1,
  };

  const [formData, setFormData] = useState(initialForm);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchStaffData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchStaffData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_warehouse_staff_details/get`);
      setStaffData(res.data || []);
    } catch (e) {
      toast.error("Failed to fetch staff data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleAddClick = () => {
    setFormData(initialForm);
    setProfileFile(null);
    setAadharFile(null);
    setLicenseFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setProfileFile(null);
    setAadharFile(null);
    setLicenseFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
    localStorage.setItem('staff_id', item.id);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name || !formData.name.trim()) newErrors.name = 'Name is required';
if (!formData.contact_no1 || !String(formData.contact_no1).trim()) {
    newErrors.contact_no1 = 'Contact number is required';
  } else if (!/^\d{10}$/.test(formData.contact_no1)) {
    newErrors.contact_no1 = 'Contact number must be exactly 10 digits';
  }

  // Optional: WhatsApp number validation
  if (formData.whatsapp_number && !/^\d{10}$/.test(formData.whatsapp_number)) {
    newErrors.whatsapp_number = 'WhatsApp number must be exactly 10 digits';
  }

  // Optional: Emergency contact validation
  if (formData.emergency_contact_no && !/^\d{10}$/.test(formData.emergency_contact_no)) {
    newErrors.emergency_contact_no = 'Emergency contact must be exactly 10 digits';
  }    
  
   if (!formData.bank_name || !formData.bank_name.trim()) {
    newErrors.bank_name = 'Bank name is required';
  }

  if (!formData.bank_branch || !formData.bank_branch.trim()) {
    newErrors.bank_branch = 'Bank branch is required';
  }

  if (!formData.bank_acno || !formData.bank_acno.trim()) {
    newErrors.bank_acno = 'Account number is required';
  } else if (!/^\d{9,18}$/.test(formData.bank_acno)) {
    newErrors.bank_acno = 'Account number must be between 9 and 18 digits';
  }

  if (!formData.bank_ifsc || !formData.bank_ifsc.trim()) {
    newErrors.bank_ifsc = 'IFSC code is required';
  } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.bank_ifsc.toUpperCase())) {
    newErrors.bank_ifsc = 'Enter a valid IFSC code (e.g., HDFC0001234)';
  }

  
  
  
  
  return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning('Please correct the highlighted fields');
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();
      // append basic fields
      Object.keys(formData).forEach(key => {
        if (key !== 'profile_image' && key !== 'aadhar_proof' && key !== 'driving_license') {
          form.append(key, formData[key] ?? '');
        }
      });
      // append files if provided
      if (profileFile) form.append('profile_image', profileFile);
      if (aadharFile) form.append('aadhar_proof', aadharFile);
      if (licenseFile) form.append('driving_license', licenseFile);

      const headers = { headers: { 'Content-Type': 'multipart/form-data' } };
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}veemart_warehouse_staff_details/update/${formData.id}`, form, headers);
      } else {
        res = await axios.post(`${var_api}veemart_warehouse_staff_details/post`, form, headers);
      }

      toast.success(res?.data?.message || 'Staff saved successfully!');
      setShowModal(false);
      setFormData(initialForm);
      setProfileFile(null);
      setAadharFile(null);
      setLicenseFile(null);
      fetchStaffData();
    } catch (err) {
      if (err?.response?.data?.errors) setErrors(err.response.data.errors);
      toast.error(err?.response?.data?.message || 'Failed to save staff');
    } finally {
      setLoading(false);
    }
  };

  const filteredData = staffData.filter(item =>
    Object.values(item).some(val => String(val || '').toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search staff..."
                  value={searchQuery}
                  onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.profile_image ? `${image_api}${String(item.profile_image).replace(/^test\//, '')}` : defaultImg}
                              alt="profile"
                              width="40"
                              height="40"
                              className="rounded"
                              onClick={() => window.open(item.profile_image ? `${image_api}${String(item.profile_image).replace(/^test\//, '')}` : defaultImg, '_blank')}
                              style={{ cursor: 'pointer' }}
                            />
                          </td>
<td
  style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
  onClick={() => {
    setViewData(item);
    setViewModal(true);
  }}
>
  {item.name}
</td>
                          <td>{item.contact_no1}</td>
                          <td>{item.role}</td>
                          {/* <td>
                            <span className={`badge ${(item.is_active === 1 || item.is_active === 'Active') ? 'bg-success' : 'bg-danger'}`}>
                              {(item.is_active === 1 || item.is_active === 'Active') ? 'Active' : 'Inactive'}
                            </span>
                          </td> */}
                          <td >
                            <Link to="#" className="btn shadow btn-xs sharp me-1" style={{ backgroundColor: "#007bff", color: "white" }} onClick={() => handleEditClick(item)}>
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >{idx + 1}</Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
<Modal show={viewModal} onHide={() => setViewModal(false)} size="xl" centered>
  <Modal.Header closeButton>
    <Modal.Title>View Staff Details</Modal.Title>
  </Modal.Header>

  {viewData && (
    <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
      <Row>
        {/* Profile Image */}
        <Col md={12} className="text-center mb-4">
          <img
            src={
              viewData.profile_image
                ? `${image_api}${viewData.profile_image.replace(/^test\//, "")}`
                : defaultImg
            }
            alt="Staff Profile"
            width="100"
            height="100"
            className="rounded border"
          />
        </Col>

        {/* 4-column field layout */}
        {[
          { label: "Name", value: viewData.name },
          { label: "Contact No 1", value: viewData.contact_no1 },
          { label: "Emergency Contact No", value: viewData.emergency_contact_no },
          { label: "Emergency Contact Relation", value: viewData.emergency_contact_relation },
          { label: "WhatsApp Number", value: viewData.whatsapp_number },
          { label: "Date of Birth", value: viewData.dob },
          { label: "Blood Group", value: viewData.blood_grp },
          { label: "Marital Status", value: viewData.marital_status },
          { label: "Anniversary", value: viewData.aniversary },
          { label: "Gender", value: viewData.gender },
          { label: "Religion", value: viewData.relegion },
          { label: "Role", value: viewData.role },
          { label: "Current Salary", value: viewData.current_salary },
          { label: "Fingerprint ID", value: viewData.fingerprint_id },
          { label: "Driving Skill", value: viewData.driving_skill },
          { label: "Driving License", value: viewData.driving_license },
          { label: "Any Medical Issue", value: viewData.any_medical_issue },
          { label: "Spouse Name", value: viewData.spouse_name },
          { label: "Father Name", value: viewData.father_name },
          { label: "Mother Name", value: viewData.mother_name },
          { label: "Language Known", value: viewData.language_known },
          { label: "Current Full Address", value: viewData.current_full_address },
          { label: "Native Full Address", value: viewData.native_full_address },
          { label: "Bank Name", value: viewData.bank_name },
          { label: "Bank Branch", value: viewData.bank_branch },
          { label: "Bank A/C No", value: viewData.bank_acno },
          { label: "Bank IFSC", value: viewData.bank_ifsc },
          { label: "Aadhar Proof", value: viewData.aadhar_proof },
        ].map((field, idx) => (
          <Col md={3} key={idx} className="mb-3">
            <strong>{field.label}:</strong>
            <div
              style={{ color: field.value ? "red" : "#6c757d" }}
            >
              {field.value ? field.value : <span className="text-secondary">—</span>}
            </div>
          </Col>
        ))}
      </Row>
    </Modal.Body>
  )}

  <Modal.Footer>
    <Button variant="danger" onClick={() => setViewModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>




        <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Staff" : "Add Staff"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
        <Row className="g-3">
  {/* Basic Info */}
  <Col md={2}>
    <Form.Group>
      <Form.Label>Name <span className="text-danger">*</span></Form.Label>
      <Form.Control type="text" name="name" value={formData.name} placeholder="Enter full name" onChange={handleInputChange} />
      {errors.name && <div className="text-danger small mt-1">{errors.name}</div>}
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Contact No <span className="text-danger">*</span></Form.Label>
      <Form.Control type="text" name="contact_no1" value={formData.contact_no1} placeholder="Primary contact no" onChange={handleInputChange} />
      {errors.contact_no1 && <div className="text-danger small mt-1">{errors.contact_no1}</div>}
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Emergency Contact</Form.Label>
      <Form.Control type="text" name="emergency_contact_no" value={formData.emergency_contact_no} placeholder="Emergency contact no" onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Emergency Relation</Form.Label>
      <Form.Control type="text" name="emergency_contact_relation" value={formData.emergency_contact_relation} placeholder="Relation" onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Whatsapp Number</Form.Label>
      <Form.Control type="text" name="whatsapp_number" value={formData.whatsapp_number} placeholder="Whatsapp no" onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>DOB</Form.Label>
      <Form.Control type="date" name="dob" value={formData.dob} onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
  <Form.Group className="mb-3">
    <Form.Label>Blood Group</Form.Label>
    <Select
      name="blood_grp"
      options={[
        { value: "A+", label: "A+" },
        { value: "A-", label: "A-" },
        { value: "B+", label: "B+" },
        { value: "B-", label: "B-" },
        { value: "O+", label: "O+" },
        { value: "O-", label: "O-" },
        { value: "AB+", label: "AB+" },
        { value: "AB-", label: "AB-" },
      ]}
      value={
        formData.blood_grp
          ? { value: formData.blood_grp, label: formData.blood_grp }
          : null
      }
      onChange={(selected) =>
        setFormData({ ...formData, blood_grp: selected?.value || "" })
      }
      isSearchable
      placeholder="Select blood group"
    />
  </Form.Group>
</Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Marital Status</Form.Label>
      <Form.Control type="text" name="marital_status" value={formData.marital_status} placeholder="Married/Single" onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Anniversary</Form.Label>
      <Form.Control type="date" name="aniversary" value={formData.aniversary} onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Current Full Address</Form.Label>
      <Form.Control as="textarea" rows={2} name="current_full_address" value={formData.current_full_address} onChange={handleInputChange} placeholder="Enter Full Address" />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Language Known</Form.Label>
      <Form.Control type="text" name="language_known" value={formData.language_known} placeholder="e.g. English, Hindi" onChange={handleInputChange} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Spouse Name</Form.Label>
      <Form.Control type="text" name="spouse_name" value={formData.spouse_name} onChange={handleInputChange} placeholder="Enter Spouse Name"/>
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Father Name</Form.Label>
      <Form.Control type="text" name="father_name" value={formData.father_name} onChange={handleInputChange}placeholder="Enter Father Name" />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Mother Name</Form.Label>
      <Form.Control type="text" name="mother_name" value={formData.mother_name} onChange={handleInputChange} placeholder="Enter Mother Name"/>
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Bank A/C No</Form.Label>
<Form.Control
  type="text"
  name="bank_acno"
  value={formData.bank_acno}
  placeholder="Enter Acc.No"
  maxLength="18"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // allow only digits
    setFormData({ ...formData, bank_acno: value });
    setErrors(prev => ({ ...prev, bank_acno: '' }));
  }}
/>
{errors.bank_acno && <div className="text-danger small mt-1">{errors.bank_acno}</div>}
    </Form.Group>
  </Col>

  <Col md={2}>
   <Form.Group className="mb-3" controlId="bank_ifsc">
  <Form.Label>IFSC Code<span className="text-danger">*</span></Form.Label>
  <Form.Control
    type="text"
    name="bank_ifsc"
    value={formData.bank_ifsc}
    placeholder="Enter IFSC Code (e.g., HDFC0001234)"
    maxLength="11"
    onChange={(e) => {
      const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""); // only alphanumeric, uppercase
      setFormData({ ...formData, bank_ifsc: value });
      setErrors((prev) => ({ ...prev, bank_ifsc: "" }));
    }}
  />
  {errors.bank_ifsc && <div className="text-danger small mt-1">{errors.bank_ifsc}</div>}
</Form.Group>
  </Col>

  <Col md={2}>
   <Form.Group className="mb-3" controlId="bank_name">
  <Form.Label>Bank Name<span className="text-danger">*</span></Form.Label>
  <Form.Control
    type="text"
    name="bank_name"
    value={formData.bank_name}
    placeholder="Enter Bank Name"
    onChange={(e) => {
      const value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // only letters and spaces
      setFormData({ ...formData, bank_name: value });
      setErrors((prev) => ({ ...prev, bank_name: "" }));
    }}
  />
  {errors.bank_name && <div className="text-danger small mt-1">{errors.bank_name}</div>}
</Form.Group>
  </Col>

  <Col md={2}>
  <Form.Group className="mb-3" controlId="bank_branch">
  <Form.Label>Branch<span className="text-danger">*</span></Form.Label>
  <Form.Control
    type="text"
    name="bank_branch"
    value={formData.bank_branch}
    placeholder="Enter Branch Name"
    onChange={(e) => {
      const value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // only letters and spaces
      setFormData({ ...formData, bank_branch: value });
      setErrors((prev) => ({ ...prev, bank_branch: "" }));
    }}
  />
  {errors.bank_branch && <div className="text-danger small mt-1">{errors.bank_branch}</div>}
</Form.Group>

  </Col>
<Col md={2}>
  <Form.Group className="mb-3">
    <Form.Label>Fingerprint ID</Form.Label>
    <Form.Control
      type="text"
      name="fingerprint_id"
      value={formData.fingerprint_id}
      placeholder="Enter fingerprint ID"
      onChange={handleInputChange}
    />
  </Form.Group>
</Col>

  {/* Profile, Aadhar, License */}
  <Col md={2}>
    <Form.Group>
      <Form.Label>Profile Image</Form.Label>
      {isEditMode && formData.profile_image && !profileFile && (
        <div className="mb-2">
          <img src={`${image_api}${String(formData.profile_image).replace(/^test\//, '')}`} alt="Preview" width="80" className="rounded border" />
        </div>
      )}
      <Form.Control type="file" accept="image/*" onChange={(e) => setProfileFile(e.target.files[0])} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Aadhar Proof</Form.Label>
      {isEditMode && formData.aadhar_proof && !aadharFile && (
        <div className="mb-2">
          <img src={`${image_api}${String(formData.aadhar_proof).replace(/^test\//, '')}`} alt="Aadhar" width="80" className="rounded border" />
        </div>
      )}
      <Form.Control type="file" accept="image/*,application/pdf" onChange={(e) => setAadharFile(e.target.files[0])} />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Driving License</Form.Label>
      {isEditMode && formData.driving_license && !licenseFile && (
        <div className="mb-2">
          <img src={`${image_api}${String(formData.driving_license).replace(/^test\//, '')}`} alt="License" width="80" className="rounded border" />
        </div>
      )}
      <Form.Control type="file" accept="image/*,application/pdf" onChange={(e) => setLicenseFile(e.target.files[0])} />
    </Form.Group>
  </Col>

 <Col md={2}>
  <Form.Group className="mb-3">
    <Form.Label>Gender</Form.Label>
    <Select
      name="gender"
      options={[
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" },
        { value: "Other", label: "Other" },
      ]}
      value={
        formData.gender
          ? { value: formData.gender, label: formData.gender }
          : null
      }
      onChange={(selected) =>
        setFormData({ ...formData, gender: selected?.value || "" })
      }
      isSearchable
      placeholder="Select gender"
    />
  </Form.Group>
</Col>


  <Col md={2}>
    <Form.Group>
      <Form.Label>Religion</Form.Label>
      <Form.Control type="text" name="relegion" value={formData.relegion} onChange={handleInputChange} placeholder="Enter Religion"/>
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Native Full Address</Form.Label>
      <Form.Control as="textarea" rows={2} name="native_full_address" value={formData.native_full_address} onChange={handleInputChange} placeholder="Enter Native Address"/>
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Driving Skill</Form.Label>
      <Form.Control type="text" name="driving_skill" value={formData.driving_skill} onChange={handleInputChange} placeholder="Enter Driving Skill"/>
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Any Medical Issue</Form.Label>
      <Form.Control type="text" name="any_medical_issue" value={formData.any_medical_issue} onChange={handleInputChange} placeholder="Medical Issues" />
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Role</Form.Label>
      <Form.Control type="text" name="role" value={formData.role} onChange={handleInputChange} placeholder="Enter Role"/>
    </Form.Group>
  </Col>

  <Col md={2}>
    <Form.Group>
      <Form.Label>Current Salary</Form.Label>
      <Form.Control type="number" name="current_salary" value={formData.current_salary} onChange={handleInputChange} placeholder="Enter Current Salary" />
    </Form.Group>
  </Col>

 {/* {isEditMode && (
  <Col md={2}>
    <Form.Group className="d-flex align-items-center gap-2 mt-4">
      <Form.Label className="mb-0">
        {formData.is_active === 1 || formData.is_active === 'Active' ? 'Active' : 'Inactive'}
      </Form.Label>
      <Form.Check
        type="switch"
        id="active-status-switch"
        checked={formData.is_active === 1 || formData.is_active === 'Active'}
        onChange={(e) =>
          setFormData({ ...formData, is_active: e.target.checked ? 1 : 0 })
        }
      />
    </Form.Group>
  </Col>
)} */}

</Row>



              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (<>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Creating...
                      </>) : ('Create')}
                    </Button>
                    <Button variant="danger" type="reset" disabled={loading} onClick={() => setFormData(initialForm)}>Reset</Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (<>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Updating...
                      </>) : ('Update')}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>Cancel</Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <style>{`
          .custom-switch-green .form-check-input:checked { background-color: #28a745 !important; border-color: #28a745 !important; }
        `}</style>

      </Card>
      <ToastContainer />
    </>
  );
};

export default StaffMaster;
